export enum ROUTES {
  NOTEBOOK = '/',
  DATA = '/data',
  STARCHART = '/provenance',
  MODELS = '/models',
  VIRTUAL_GRAPHS = '/virtual-graphs',
  DATABASES = '/databases',
  SECURITY = '/security',
}

export enum NotebookParam {
  DATABASE = 'db',
  GRAPH = 'graph',
  MODEL = 'model',
}

export enum NotebookParamKey {
  databaseId = 'databaseId',
  model = 'model',
  namedGraphs = 'namedGraphs',
}

export type NotebookParams = {
  databaseId: string;
  model: string;
  namedGraphs: string[];
};
